<template>
  <label class="ms-radio" @keypress="keyDownActive" @focus="onFocus" @blur="onBlur">
    <input
      type="radio"
      :name="name"
      :value="keyValue"
      :checked="value"
      @input="$emit('input', keyValue)"
      @change="$emit('change', $event)"
      :disabled="disabled"
    />
    <span class="checkmark"></span>
    <span v-if="text" class="ms-radio--text">{{ text }}</span>
  </label>
</template>
<script>
export default {
  name: "msRadio",
  props: {
    value: {},
    text: {
      default: null,
      type: String,
    },
    keyValue: {
      default: null,
    },
    name: {
      default: null,
      type: String,
    },
    type: {
      default: "radio",
      type: String,
    },
    cssLabel: {
      default: null,
      type: String,
    },
    cssText: {
      default: null,
      type: String,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    keyDownActive(e) {
      event.preventDefault();
      switch (e.which) {
        case 32:
        case 13:
          this.$emit("input", this.keyValue);
          break;
      }
    },
    onFocus(e) {
      const me = this;
      me.focused = true;
    },
    onBlur(e) {
      const me = this;
      me.focused = false;
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
      };
    },
  },
  data() {
    return {
      focused: false,
    };
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
// @media screen and (max-width: 1366px) {
//   @import "@/assets/scss/_sm-variables.scss";
//   @import "@/assets/scss/components/msRadio.scss";
// }
// @media screen and (min-width: 1367px) {
//   @import "@/assets/scss/_variables.scss";
//   @import "@/assets/scss/components/msRadio.scss";
// }
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/components/msRadio.scss";
</style>
